import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Money from '@material-ui/icons/Money';
import Beenhere from '@material-ui/icons/Beenhere';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function AboutUs(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container } justify="center" align="center">
            <br/>
            <h2 className={classes.title}>About Us</h2>
            <p className={classes.description}>We are an online-based ridesharing company that helps people to reach different places at the most affordable rates. </p>
<br/>
<p className={classes.description}> Our customers are most valuable to us. We are consistently working to deliver outstanding services above the expectations of the customers. We treat every customer equally essential to build long term relations with them. </p>
<br/>
<p className={classes.description}> We provide a reliable and cost-effective medium that helps people connect with others anywhere and at any time. </p>
<br/>
<p className={classes.description}> Through rideshare, you can book a ride in just a few taps of a smartphone. All you need is to download the app and select the pickup location. Then select drop location and car type. Click the book now or schedule it for later. With our drivers we aim to be professional as possible, with drivers for high-end services to just your everyday drivers. We have you covered! Join us today to be a driver or a rideshare your part of our big family! </p>
            <br/>
        </div>
        <GridContainer justify="center" align="center">
        <GridItem xs={12} sm={12} md={6} justify="center">
            <InfoArea
              title="MISSION STATEMENT"
              description="Every day is the new opportunity to make a difference by empowering each ride to change the way our world is one by one. Each day is a new day to make a difference! "
              icon={Beenhere}
              iconColor="danger"
              align-content="center"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6} justify="center">
            <InfoArea
              title="VISION STATEMENT"
              description="To provide an affordable and comfortable ride in one place. We are changing the way of traveling in our world where transport brings people together instead of apart. We know theirs is a future as a community, and it starts with each one of us. 
"
              icon={Money}
              iconColor="danger"
              align-content="center"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6} justify="center">
            <h3 className={classes.title}>“Empowering each opportunity”</h3>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} justify="center">
            <h3 className={classes.title}>“Our vision is to create a better <br/> every-day life for all people” <br/> <br/></h3>
          </GridItem>
          </GridContainer>
        </div>
      <Footer />
    </div>
  );
}
